<div class="p-1 pt-3">
  <div class="d-flex align-items-center mb-3 gap-2 flex-wrap">
    <h4 class="mb-0 me-auto">Users</h4>

    <!-- Search -->
    <div class="input-group input-group-sm" style="width: 260px">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
      <input
        type="search"
        class="form-control"
        placeholder="Search by name…"
        [ngModel]="search()"
        (ngModelChange)="search.set($event)"
        (keyup.enter)="applySearch()"
        (search)="applySearch()"
      >
      <button class="btn btn-outline-secondary" type="button" (click)="applySearch()">Search</button>
    </div>
  </div>

  @if (loading()) {
    <div class="text-muted py-4 text-center">
      <span class="spinner-border spinner-border-sm me-2" role="status"></span>Loading…
    </div>
  } @else if (error()) {
    <div class="alert alert-danger">{{ error() }}</div>
  } @else {
    <table class="table table-hover align-middle mb-2">
      <thead class="table-light">
        <tr>
          <th>Email</th>
          <th>Name</th>
          <th>Type</th>
          <th>Status</th>
          <th>Created</th>
        </tr>
      </thead>
      <tbody>
        @for (u of items(); track u.id) {
          <tr class="cursor-pointer" (click)="openUser(u.id)">
            <td class="fw-semibold">{{ u.email }}</td>
            <td>{{ u.name }}</td>
            <td>{{ u.type }}</td>
            <td>{{ u.status }}</td>
            <td>{{ u.created | date:'d MMM y, HH:mm' }}</td>
          </tr>
        } @empty {
          <tr>
            <td colspan="5" class="text-center text-muted py-4">No users.</td>
          </tr>
        }
      </tbody>
    </table>

    <!-- Pagination footer -->
    <div class="d-flex align-items-center gap-3 flex-wrap">
      <small class="text-muted">
        @if (totalCount() > 0) {
          {{ pageStart() }}–{{ pageEnd() }} of {{ totalCount() }} users
        }
      </small>
      <nav class="ms-auto" aria-label="Users pagination">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" [class.disabled]="page() <= 1">
            <button class="page-link" (click)="goToPage(1)" [disabled]="page() <= 1" title="First">
              <i class="bi bi-chevron-double-left"></i>
            </button>
          </li>
          <li class="page-item" [class.disabled]="page() <= 1">
            <button class="page-link" (click)="goToPage(page() - 1)" [disabled]="page() <= 1" title="Previous">
              <i class="bi bi-chevron-left"></i>
            </button>
          </li>
          <li class="page-item disabled">
            <span class="page-link">{{ page() }} / {{ totalPages() }}</span>
          </li>
          <li class="page-item" [class.disabled]="page() >= totalPages()">
            <button class="page-link" (click)="goToPage(page() + 1)" [disabled]="page() >= totalPages()" title="Next">
              <i class="bi bi-chevron-right"></i>
            </button>
          </li>
          <li class="page-item" [class.disabled]="page() >= totalPages()">
            <button class="page-link" (click)="goToPage(totalPages())" [disabled]="page() >= totalPages()" title="Last">
              <i class="bi bi-chevron-double-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  }
</div>
